<template>
  <div :class="$style['service-banner']">
    <h2 :class="$style['service-banner__title']">
      {{ $t('partials/service-need-help') }}
    </h2>
    <p>{{ $t('partials/service-youve-got-questions') }}</p>

    <grid>
      <cell
        size="12"
        tablet="4">
        <a
          :class="$style['service-banner__item']"
          :href="
            $lang === 'de'
              ? 'tel:+4939292678217'
              : 'tel:+31850471747'
          ">
          <svg-icon
            :class="$style['service-banner__icon']"
            name="Device/phone-line" />
          <h4>{{ $t('partials/service-telnr') }}</h4>
          <span :class="$style['description']">{{
            $t('partials/service-tringeling')
          }}</span>
        </a>
      </cell>
      <cell
        size="12"
        tablet="4">
        <NuxtLink
          :to="{ name: `${$lang}-service` }"
          :class="$style['service-banner__item']">
          <svg-icon
            :class="$style['service-banner__icon']"
            name="Communication/question-answer-line" />
          <h4>{{ $t('general/faqs') }}</h4>
          <span>{{ $t('partials/see-common-asked-questions') }}</span>
        </NuxtLink>
      </cell>
      <cell
        size="12"
        tablet="4">
        <a
          :href="
            $lang === 'de'
              ? 'mailto:service@gutsgusto.de'
              : 'mailto:info@gutsgusto.com'
          "
          :class="$style['service-banner__item']">
          <svg-icon
            :class="$style['service-banner__icon']"
            name="Business/mail-line" />
          <h4>{{ $t('partials/service-email') }}</h4>
          <span>{{ $t('partials/we-respond-very-fast') }}</span>
        </a>
      </cell>
    </grid>
  </div>
</template>
<script setup>

</script>
<style module lang="scss">
.service-banner {
  background-color: var(--white);
  box-shadow: var(--box-shadow-large);
  border-radius: calc(var(--border-radius) * 2);

  // border: 5px solid var(--grey-lighter);
  text-align: center;
  padding: calc(var(--spacing) * 2);

  &__title {
    font-size: var(--font-size-xl);
    margin-bottom: var(--line-height);
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: calc(var(--spacing) * 2);
    text-decoration: none;
  }

  &__icon {
    opacity: 0.25;
    width: calc(calc(var(--spacing ) * 6));
    height: calc(var(--spacing ) * 6);
  }
}
</style>
